export default __webpack_public_path__ + "static/media/prev_push.4d164ec5.svg";